import { IProduct } from "../types/product.type";
import { ISelectsInput } from "../types/selects.type";

interface IOrderProduct {
  count: number;
  product: IProduct;
}

export interface ICalculateOrder {
  total: number;
  products: IOrderProduct[];
}

export const calculateOrder = (
  selects: ISelectsInput[],
  products: IProduct[]
): ICalculateOrder => {
  const selectedProducts: IOrderProduct[] = [];
  for (const product of products) {
    for (const select of selects) {
      if (select.id === product.id) {
        if (select.selectCount) {
          selectedProducts.push({ count: Number(select.selectCount), product });
        }
      }
    }
  }
  const total = selectedProducts.reduce(
    (acc, item) => (acc += item.count * Number(item.product.price)),
    0
  );
  return { total, products: selectedProducts };
};
